import { render, staticRenderFns } from "./EmojiPickerContainer.vue?vue&type=template&id=79af007f&scoped=true&"
import script from "./EmojiPickerContainer.vue?vue&type=script&lang=js&"
export * from "./EmojiPickerContainer.vue?vue&type=script&lang=js&"
import style0 from "./EmojiPickerContainer.vue?vue&type=style&index=0&id=79af007f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af007f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
